const normalizeSearchText = (value = '') => value
  .toLocaleLowerCase()
  .trim()
  .replace(/\s+/g, ' ');

const scoreOption = (option, query) => {
  const label = normalizeSearchText(option.label);
  const searchable = normalizeSearchText(`${option.label} ${option.keywords || ''}`);
  const normalizedQuery = normalizeSearchText(query);
  if (!normalizedQuery) return option.pinned ? -1000 : 0;

  const tokens = normalizedQuery.split(' ');
  if (!tokens.every((token) => searchable.includes(token))) return Number.POSITIVE_INFINITY;
  if (label === normalizedQuery) return -500;
  if (label.startsWith(normalizedQuery)) return -400;

  const phraseIndex = label.indexOf(normalizedQuery);
  if (phraseIndex >= 0) return -300 + phraseIndex;

  const words = label.split(' ');
  let score = 0;
  let previousWordIndex = -1;
  tokens.forEach((token) => {
    let bestScore = 1000;
    let bestWordIndex = -1;
    words.forEach((word, wordIndex) => {
      const containsIndex = word.indexOf(token);
      if (containsIndex < 0) return;
      const wordScore = word === token ? 0 : word.startsWith(token) ? 10 : 30 + containsIndex;
      if (wordScore < bestScore) {
        bestScore = wordScore;
        bestWordIndex = wordIndex;
      }
    });
    score += bestScore;
    if (previousWordIndex >= 0 && bestWordIndex < previousWordIndex) score += 25;
    previousWordIndex = bestWordIndex;
  });
  return score;
};

export const rankAutocompleteOptions = (options, query) => options
  .map((option, originalIndex) => ({ option, originalIndex, score: scoreOption(option, query) }))
  .filter((entry) => Number.isFinite(entry.score))
  .sort((left, right) => left.score - right.score || left.originalIndex - right.originalIndex)
  .map((entry) => entry.option);